module.exports = __webpack_public_path__ + "static/media/app-store.8fc4b177.png";